"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74482 2.74417C7.90106 2.58788 8.11299 2.50005 8.33398 2.5H11.6673C12.3304 2.5 12.9662 2.76339 13.4351 3.23223C13.9039 3.70107 14.1673 4.33696 14.1673 5V12.5C14.1673 13.163 13.9039 13.7989 13.4351 14.2678C12.9662 14.7366 12.3304 15 11.6673 15H5.83398C5.17094 15 4.53506 14.7366 4.06622 14.2678C3.59738 13.7989 3.33398 13.163 3.33398 12.5V7.5C3.33403 7.279 3.42186 7.06708 3.57815 6.91083L7.74482 2.74417ZM11.6673 4.16667H9.16732V7.5C9.16732 7.72101 9.07952 7.93297 8.92324 8.08926C8.76696 8.24554 8.555 8.33333 8.33398 8.33333H5.00065V12.5C5.00065 12.721 5.08845 12.933 5.24473 13.0893C5.40101 13.2455 5.61297 13.3333 5.83398 13.3333H11.6673C11.8883 13.3333 12.1003 13.2455 12.2566 13.0893C12.4129 12.933 12.5007 12.721 12.5007 12.5V5C12.5007 4.77899 12.4129 4.56702 12.2566 4.41074C12.1003 4.25446 11.8883 4.16667 11.6673 4.16667ZM6.17898 6.66667H7.50065V5.345L6.17898 6.66667ZM15.834 4.16667C16.055 4.16667 16.267 4.25446 16.4232 4.41074C16.5795 4.56702 16.6673 4.77899 16.6673 5V15C16.6673 15.663 16.4039 16.2989 15.9351 16.7678C15.4662 17.2366 14.8304 17.5 14.1673 17.5H5.83398C5.61297 17.5 5.40101 17.4122 5.24473 17.2559C5.08845 17.0996 5.00065 16.8877 5.00065 16.6667C5.00065 16.4457 5.08845 16.2337 5.24473 16.0774C5.40101 15.9211 5.61297 15.8333 5.83398 15.8333H14.1673C14.3883 15.8333 14.6003 15.7455 14.7566 15.5893C14.9129 15.433 15.0007 15.221 15.0007 15V5C15.0007 4.77899 15.0884 4.56702 15.2447 4.41074C15.401 4.25446 15.613 4.16667 15.834 4.16667Z",
    fill: fill
  }));
};

exports["default"] = _default;